import { SvgIcon, SvgIconProps } from '@mui/material';
import { white } from '@/lib/colours';

export function FenceIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Group">
          <path
            id="Vector"
            d="M18 7.00145C18 6.45145 17.55 6.00145 17 6.00145H16V3.00145L13.71 0.711445C13.32 0.321445 12.69 0.321445 12.3 0.711445L11 2.00145L9.71 0.711445C9.32 0.321445 8.69 0.321445 8.3 0.711445L7 2.00145L5.71 0.711445C5.32 0.321445 4.69 0.321445 4.3 0.711445L2 3.00145V6.00145H1C0.45 6.00145 0 6.45145 0 7.00145C0 7.55145 0.45 8.00145 1 8.00145H2V10.0014H1C0.45 10.0014 0 10.4514 0 11.0014C0 11.5514 0.45 12.0014 1 12.0014H2V15.0014C2 15.5514 2.45 16.0014 3 16.0014H15C15.55 16.0014 16 15.5514 16 15.0014V12.0014H17C17.55 12.0014 18 11.5514 18 11.0014C18 10.4514 17.55 10.0014 17 10.0014H16V8.00145H17C17.55 8.00145 18 7.55145 18 7.00145ZM13 2.83145L14 3.83145V6.00145H12V3.83145L12.41 3.42145L13 2.83145ZM9 2.83145L9.59 3.42145L10 3.83145V6.00145H8V3.83145L8.41 3.42145L9 2.83145ZM8 10.0014V8.00145H10V10.0014H8ZM10 12.0014V14.0014H8V12.0014H10ZM4 3.83145L5 2.83145L5.59 3.42145L6 3.83145V6.00145H4V3.83145ZM4 8.00145H6V10.0014H4V8.00145ZM4 12.0014H6V14.0014H4V12.0014ZM14 14.0014H12V12.0014H14V14.0014ZM14 10.0014H12V8.00145H14V10.0014Z"
            fill={white[900]}
          />
        </g>
      </svg>
    </SvgIcon>
  );
}
